import React from 'react';
import { ApplicationState } from '../../reducers';
import { useDispatch, useSelector } from 'react-redux';
import { ComponentManagementActionType } from '../../reducers/comp.actions';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { deleteNodeById } from '../../api/node';
import { TitleTree } from '../../domain/domain';
import { UiActionType } from '../../reducers/ui.reducer';
import { findSubTreeByNodeId } from './utils';

const RemoveNodeDialog: React.FC = () => {

    const open = useSelector((app: ApplicationState) => app.comp.removeNodeDialogOpen);
    const dispatch = useDispatch();
    const contextMenuSubTree = useSelector((app: ApplicationState) => app.comp.removeNodeDialogSubTree);
    const root = useSelector((app: ApplicationState) => app.comp.treeRoot);

    if (!contextMenuSubTree) {
        return <></>
    }

    const onCancel = () => {
        dispatch({ type: ComponentManagementActionType.REMOVE_NODE_DIALOG_OPEN, open: false })
    }

    const onDelete = () => {
        if (!contextMenuSubTree) {
            return;
        }

        deleteNodeById(contextMenuSubTree?.nodeId).then(_ => {
            let parentSubTree: TitleTree | undefined = findSubTreeByNodeId(root!, contextMenuSubTree?.parentId);
            if (parentSubTree === undefined) {
                return;
            }
            let newParentChildren = [...parentSubTree.children];
            let idx: number = newParentChildren.findIndex(subTree => subTree.nodeId === contextMenuSubTree?.nodeId);
            if (idx >= 0) {
                newParentChildren.splice(idx, 1);
                parentSubTree.children = newParentChildren;
                newParentChildren.forEach((childTree) => {
                    let childPosition = childTree.ordinal;
                    if (childPosition >= contextMenuSubTree.ordinal!) {
                        childTree.ordinal = childPosition - 1
                    }
                })
                dispatch({ type: ComponentManagementActionType.TREE_ROOT_UPDATED, treeRoot: { ...root! } });
                dispatch({ type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { open: true, message: "Provision Removed", severity: "success" } });
            }
        }).catch(error => {
            dispatch({ type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { open: true, message: "Could not remove provision", severity: "error" } });
            console.error(error);
        })
        dispatch({ type: ComponentManagementActionType.REMOVE_NODE_DIALOG_OPEN, open: false, subTree: contextMenuSubTree });
    }

    return (
        <Dialog maxWidth='sm' fullWidth={true} open={open} onClose={() => { }}>
            <DialogTitle disableTypography={true}>
                <Typography variant='h4'>Remove Provision</Typography>
            </DialogTitle>
            <DialogContent>
                Are you sure you want to remove this Provision ({contextMenuSubTree?.citation || contextMenuSubTree?.heading}) and its children?
            </DialogContent>
            <DialogActions>
                <Button size='small' variant='outlined' color='primary' onClick={onCancel}>Cancel</Button>
                <Button size='small' variant='outlined' color='secondary' onClick={onDelete}>Remove</Button>
            </DialogActions>
        </Dialog>
    )
}

export default RemoveNodeDialog;
